import storeApi from '../../../api/stores';


const capitalize = (s) => {
    return s
        .toLowerCase()
        .replace(/\b./g, function (a) {
            return a.toUpperCase();
        });
};

export const OrdersNavigation = [
    {
        text: 'Awaiting Payment',
        icon: 'money',
        items: [
            {
                id:0,
                text: 'All Stores',
                path: `/orders/awaiting-payment`
            },{
                id:1,
                text: 'Manual Orders',
                path: `/orders/awaiting-payment/manual-orders`
            }
        ]
    }, {
        text: 'On Hold',
        icon: 'save',
        items: [
            {
                id:0,
                text: 'All Stores',
                path: `/orders/on-hold`
            },{
                id:1,
                text: 'Manual Orders',
                path: `/orders/on-hold/manual-orders`
            }
        ]
    }, {
        text: 'Awaiting Shipment',
        icon: 'box',
        items:[
            {
                id:0,
                text: 'All Stores',
                path: `/orders/awaiting-shipment`
            },{
                id:1,
                text: 'Manual Orders',
                path: `/orders/awaiting-shipment/manual-orders`
            }
        ]
    }, {
        text: 'Shipped',
        icon: 'gift',
        items: [
            {
                id:0,
                text: 'All Stores',
                path: `/orders/shipped`
            },{
                id:1,
                text: 'Manual Orders',
                path: `/orders/shipped/manual-orders`
            }
        ]
    }, {
        text: 'Cancelled',
        icon: 'close',
        items: [
            {
                id:0,
                text: 'All Stores',
                path: `/orders/cancelled`
            },{
                id:1,
                text: 'Manual Orders',
                path: `/orders/cancelled/manual-orders`
            }
        ]
    }, {
        text: 'Ordered Alert',
        icon: 'warning',
        path: '/orders/ordered-alert'
    }
];
